import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError, timer } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import * as HttpStatus from 'http-status-codes';
import { WINDOW } from '@fpr/core/services/window.factory';
import { InterceptorSkipHeader } from '@fpr/core/services/vas.service';
import { LocaleService } from '@fpr/core/services/locale.service';
import { ConfigService } from '@fpr/core/services/config.service';

@Injectable({
    providedIn: 'root',
    deps: [Router, WINDOW]
})
export class ErrorInterceptor implements HttpInterceptor {
    private readonly window = inject<Window>(WINDOW);
    private readonly router = inject(Router);
    private readonly httpClient = inject(HttpClient);
    private readonly localeService = inject(LocaleService);
    private readonly configService = inject(ConfigService);


    private readonly AUTH_ERROR_STATUS_CODES = [HttpStatus.UNAUTHORIZED, HttpStatus.FORBIDDEN];

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req)
            .pipe(
                catchError((err: HttpErrorResponse) => {

                    if (err instanceof HttpErrorResponse) {

                        // auth errors
                        if (this.AUTH_ERROR_STATUS_CODES.includes(err.status)) {
                            this.window.location.href = this.localeService.getPathWithLocale(this.configService.LOGIN_URI);

                            return EMPTY;
                        }

                        // throttle errors
                        if (err.status === HttpStatus.TOO_MANY_REQUESTS) {

                            const retryAfter = parseInt(err.headers.get('retry-after'), 10);
                            const retryAfterMillis = retryAfter * 1000;
                            const session = err.headers.get('x-fp-session');

                            if (retryAfter) {

                                const modifiedHeaders = req.headers.set('x-fp-session', session);

                                const modifiedReq = req.clone({
                                    headers: modifiedHeaders
                                });

                                return timer(retryAfterMillis)
                                    .pipe(
                                        mergeMap(_ => this.httpClient.request(modifiedReq))
                                    );

                            }

                            return throwError(() => err);

                        }

                        // default errors
                        if (!req.headers.has(InterceptorSkipHeader)) {
                            this.router.navigate(['/error']);

                            return EMPTY;
                        }

                        // all other errors need to be handled inside feature module
                        return throwError(() => err);

                    }

                    return throwError(() => err);

                })
            );

    }

}
